export default __webpack_public_path__ + "static/media/tt-5g-white.6814b831.png";